import { i18n } from '@/plugins/i18n'

function excelStatusVariant(status) {
    if (status === 'CREATED') {
        return 'badge-secondary';
    }
    if (status === 'PROCESSING') {
        return 'badge-warning';
    }
    if (status === 'PROCESSED') {
        return 'badge-success';
    }
    return 'badge-secondary';
}

export default [
    {
        field: 'id',
        title: '#',
        sortable: true,
        width: 70,
        type: 'number',
        textAlign: 'center',
    },
    {
        field: 'from_date',
        title: i18n.t('label.from_date'),
        sortable: false,
        textAlign: 'center',
    },
    {
        field: 'to_date',
        title: i18n.t('label.to_date'),
        sortable: false,
        textAlign: 'center',
    },
    {
        field: 'status',
        sortable: false,
        textAlign: 'center',
        title: i18n.t('label.status'),
        template: (row) => {
            let status = row.status ? i18n.t('transaction.excelStatus.' + row.status.toLowerCase()) : '';
            let variant = 'btn ' + excelStatusVariant(row.status);

            return `
                <button class="${variant} text-white status-badge">
                    ${status}
                </button>`;
        },
        width: 100
    },
    {
        field: 'url',
        title: i18n.t('label.download_link'),
        sortable: false,
        width: 80,
        textAlign: 'center',
        template: (row) => {
            if (row.status === 'PROCESSED') {
                return `
                    <a href="${row.url}"
                       class="fa fa-download"
                       title="${i18n.t('label.download')}">
                    </a>`;
            }

            return '';
        }
    }
];
